import { Component, AfterViewInit } from '@angular/core';
import { OmniChatFacade } from '@cigna/omni/chat-state';

@Component({
  selector: 'cigna-omni-chat-history',
  templateUrl: './history.component.html',
})
export class HistoryComponent implements AfterViewInit {
  constructor(private chatFacade: OmniChatFacade) {}

  ngAfterViewInit() {
    this.chatFacade.historyView();
  }
}
